import { AfterViewInit, Component, ComponentFactoryResolver, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { AppService } from "@api";
import { AlineacionImagenEnum } from "@componentes/Enums.enum";
import { FiltroModel } from "@componentes/Filtros/Filtro.model";
import { FiltrosComponent } from "@componentes/Filtros/Filtros.component";
import { TipoFiltroEnum } from "@componentes/Filtros/Filtros.enum";
import { RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { AlertaEnum } from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { AcuerdoFirma } from "@modelo/proceso/acuerdofirma.model";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";


@Component(
    {
        selector: 'consultaacuerdo_acuerdo',
        templateUrl: './consultaacuerdo_acuerdo.component.html',
        styleUrls: ['./consultaacuerdo_acuerdo.component.scss']
    })

export class ConsultaAcuerdoAcuerdoComponent implements AfterViewInit{
  @Input() entidad!: any;
  @Input() accion!: {accionid: number, accion: string};
  @Output() output = new EventEmitter();
  consulta!: boolean;
  abierto!: boolean;
  public animacion!: string;
  public login: {Cuenta: string, Id: string, Password: string, errorActivo?: boolean};
  public verPassword: boolean = false;
  public errorActivo: boolean = false;

  tipofirma: number = 0;

  entidadacuerdo:AcuerdoFirma = new AcuerdoFirma();
  entidadacuerdoactual:AcuerdoFirma = new AcuerdoFirma();


  public AlineacionImagenEnum = AlineacionImagenEnum;
  constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver){
    this.login = {Cuenta: "", Id: "", Password: ""};
    }

    ngAfterViewInit(){
      this.listaacuerdoanterior();
    }

    Salir(){
      this.output.next();
    }

    listaacuerdoanterior(){
      this.appService.Post("acuerdo/buscaracuerdodetalle",this.entidad).then(res => {
        if(res.status == RespuestaEstatusEnum.Success){
          if(res.data.anterior){
            this.entidadacuerdo = new AcuerdoFirma(res.data.anterior);
          }
          if(res.data.actual){
            this.entidadacuerdoactual = new AcuerdoFirma(res.data.actual[0]);
          }
        }
      })
    }

    guardarborrador(){
      this.appService.Post("acuerdo/guardaracuerdo",{"entidad":this.entidad, "acuerdo":this.entidadacuerdoactual}).then(res=>{
        if(res.status == RespuestaEstatusEnum.Success){
          this.entidadacuerdoactual = new AcuerdoFirma(res.data);
        }
      })
    }

    ModalInterno(){
      this.animacion = this.sistemaService.animacionAbirModal;
      this.abierto = true;
    }

    CerrarModalInterno(){
      this.animacion = this.sistemaService.animacionCerrarModal;
      this.login = {Cuenta: "", Id: "", Password: ""};
      setTimeout(() => {
          this.abierto = false;
      }, 310);
    }

    formulario(e:number){
      if(this.entidadacuerdoactual.textoacuerdo != "" && this.entidadacuerdoactual.asignacionacuerdofirmaid != 0){
        switch(e){
          case 1:
            this.tipofirma = e;
            break;
          case 2:
            this.tipofirma = e;
            break;
        }
        this.ModalInterno();
      }else{
        this.mensajeService.Alerta(AlertaEnum.Warning, "primero se tiene que guardar el acuerdo antes de realizar la firma");
      }
    }

    GuardarFirma(){
      if(this.login.Cuenta != "" && this.login.Password != ""){
        let pass = this.appService.EncriptarDatos({Password: this.login.Password});
        var datos = {Cuenta: this.login.Cuenta, Password: pass};
        this.appService.Post("acuerdo/guardarfirma", {"entidad": this.entidad, "acuerdo": this.entidadacuerdoactual, "tipofirma":this.tipofirma, "login": datos}).then(res=>{
          if(res.status == RespuestaEstatusEnum.Success){
            this.CerrarModalInterno();
            this.listaacuerdoanterior();
            this.login = {Cuenta: "", Id: "", Password: ""};
          }
        })
      }else{
        this.mensajeService.Alerta(AlertaEnum.Warning,"No se ah asignado la cuenta o la contraseña")
      }
    }

    CambiarVerPassword() {
      this.verPassword = !this.verPassword;
  }
  }
